import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { css } from 'styled-components';
import { Box } from '../Box';
import { createComponent } from '../utils';
var getPadding = function (p) { return (typeof p.gutter === 'number' ? p.gutter : p.theme.gridGutter); };
var StyledContainer = createComponent({
    name: 'Container',
    as: Box,
    style: function (_a) {
        var maxWidth = _a.maxWidth, fluid = _a.fluid, theme = _a.theme;
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    max-width: ", ";\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "], ["\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    max-width: ", ";\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "])), fluid ? '100%' : (maxWidth || theme.gridWidth) + "px", getPadding, getPadding);
    },
});
StyledContainer.displayName = 'Container';
export var Container = function (_a) {
    var gutter = _a.gutter, children = _a.children, rest = __rest(_a, ["gutter", "children"]);
    return (React.createElement(StyledContainer, __assign({ gutter: gutter }, rest), React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { gutter: gutter });
        }
        return child;
    })));
};
var templateObject_1;
//# sourceMappingURL=Container.js.map